import React from 'react'
import { Select, Button, MagicInput } from 'hljd'
import { Upload } from 'hlj-components'
import { observer } from 'mobx-react'
import DocumentList from './DocumentList'
import style from './style.module.less'
import { getRequestUrl } from '@util'

const Option = Select.Option
const SelectSearchStyle = {
  width: 240
}
const maxInputStyle = {
  width: 600
}
const buttonStyle = {
  width: 160,
  height: 40,
  margin: '0 20px'
}

export default observer(
  ({
    store: {
      name,
      desc,
      nameList = [],
      changeName,
      searchName,
      changeDescription,
      certificationInfo,
      changeCertificationInfo,
      certificationBrand,
      changeCertificationBrand,
      checkImageSize,
      checkFileSize,
      discard,
      submit,
      deleteCertificationInfo,
      deleteCertificationBrand
    }
  }) => (
    <div className={style.container}>
      <div className={style.topBar}>
        <span className={style.name}>品牌名称</span>
        <Select
          placeholder="请选择"
          showSearch
          optionFilterProp="children"
          style={SelectSearchStyle}
          value={name}
          onChange={changeName}
          onSearch={searchName}
          filterOption={false}
        >
          {nameList.map(({ id, name }) => {
            return (
              <Option key={id} value={id}>
                {name}
              </Option>
            )
          })}
        </Select>
      </div>
      <div className={style.infoList}>
        <div className={style.listGroup}>
          <div className={style.label}>认证说明：</div>
          <div className={style.info}>
            <p className={style.textInfo}>请详细说明品牌代理信息</p>
            <MagicInput.TextArea
              maxLength={200}
              rows={5}
              value={desc}
              showCount
              countPosition="inner"
              style={maxInputStyle}
              onChange={e => changeDescription(e.target.value)}
            />
          </div>
        </div>
        <div className={style.listGroup}>
          <div className={style.label}>证明材料：</div>
          <div className={style.info}>
            <p className={style.textInfo}>
              请上传1-5张品牌代理相关证明文件，以图片形式提交，证明代理信息属实
              <br />
              图片限制10M，支持<span className={style.heightLight}>
                JPG、PNG
              </span>和<span className={style.heightLight}>BMP</span>等大部分格式，需要上传1-5张
            </p>
            <div className={style.wapper}>
              <DocumentList
                list={certificationInfo}
                onDelete={deleteCertificationInfo}
              >
                {certificationInfo.length < 5 && (
                  <Upload
                    multiple={true}
                    onOk={changeCertificationInfo}
                    onError={checkImageSize}
                    uptoken_url={getRequestUrl(
                      '/hms/mediacenter/appApi/media/token?appId=19160ce307ef6c0eae33d2cdc166ef4c&type=0',
                      // eslint-disable-next-line
                      __JAVA__DOMAIN__
                    )}
                    tokenPath={res => res.data.upToken}
                    max_file_size="10mb"
                    filters={{
                      mime_types: [
                        {
                          title: 'images files',
                          extensions: 'jpg,png,jpeg,bmp'
                        }
                      ],
                      max_file_size: '10mb',
                      prevent_duplicates: true
                    }}
                  >
                    <div className={style.upload}>
                      <div className={style.icon}>
                        <img
                          className={style.iconSvg}
                          src="https://qnm.hunliji.com/o_1d714hjqsa7iio6ubm1c23vme9.png"
                        />
                      </div>
                      <p className={style.des}>上传图片</p>
                    </div>
                  </Upload>
                )}
              </DocumentList>
            </div>
          </div>
        </div>
        <div className={style.listGroup}>
          <div className={style.labelNotMust}>品牌资料：</div>
          <div className={style.info}>
            <p className={style.textInfo}>
              请上传与品牌相关资料信息，以介绍品牌，向客户传递品牌理念为主<br />
              文件限制50M，支持<span className={style.heightLight}>
                doc、docx、PDF、JPG、PNG
              </span>和<span className={style.heightLight}>BMP</span>等大部分格式，最多上传10个文件
            </p>
            <div className={style.wapper}>
              <DocumentList
                list={certificationBrand}
                onDelete={deleteCertificationBrand}
              >
                {certificationBrand.length < 10 && (
                  <>
                    <Upload
                      multiple={true}
                      onOk={changeCertificationBrand}
                      onError={checkImageSize}
                      uptoken_url={getRequestUrl(
                        '/hms/mediacenter/appApi/media/token?appId=19160ce307ef6c0eae33d2cdc166ef4c&type=0',
                        // eslint-disable-next-line
                        __JAVA__DOMAIN__
                      )}
                      tokenPath={res => res.data.upToken}
                      filters={{
                        mime_types: [
                          {
                            title: 'images files',
                            extensions: 'jpg,png,jpeg,bmp'
                          }
                        ]
                      }}
                      max_file_size="10mb"
                    >
                      <div className={style.upload}>
                        <div className={style.icon}>
                          <img
                            className={style.iconSvg}
                            src="https://qnm.hunliji.com/o_1d714hjqsa7iio6ubm1c23vme9.png"
                          />
                        </div>
                        <p className={style.des}>上传图片</p>
                      </div>
                    </Upload>
                    <Upload
                      multiple={true}
                      onOk={changeCertificationBrand}
                      onError={checkFileSize}
                      uptoken_url={getRequestUrl(
                        '/hms/mediacenter/appApi/media/token?appId=448e6f1c2f0950ac7e49c0615f98e931&type=1',
                        // eslint-disable-next-line
                        __JAVA__DOMAIN__
                      )}
                      tokenPath={res => res.data.upToken}
                      region={'up-z2.qiniup.com'}
                      domain={'https://qndoc.hunliji.com/'}
                      max_file_size="50mb"
                      filters={{
                        max_file_size: '50mb',
                        prevent_duplicates: true,
                        mime_types: [
                          {
                            extensions: 'doc,docx,pdf,xls,xlsx'
                          }
                        ]
                      }}
                    >
                      <div className={style.upload}>
                        <div className={style.icon}>
                          <div className={style.iconAdd}>+</div>
                        </div>
                        <p className={style.des}>上传文件</p>
                      </div>
                    </Upload>
                  </>
                )}
              </DocumentList>
            </div>
          </div>
        </div>
        {/* 提交按钮 */}
        <div className={style.buttonWapper}>
          <Button style={buttonStyle} type="default" onClick={discard}>
            取 消
          </Button>
          <Button style={buttonStyle} type="primary" onClick={submit}>
            提交审核
          </Button>
        </div>
      </div>
    </div>
  )
)
